var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPencil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3724_53)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8774 0.212938L15.7865 3.12206C15.9229 3.25844 15.9995 3.4434 15.9995 3.63624C15.9995 3.82909 15.9229 4.01405 15.7865 4.15043L13.7552 6.18172L9.81775 2.24423L11.849 0.212938C11.9854 0.0765938 12.1704 0 12.3632 0C12.5561 0 12.741 0.0765938 12.8774 0.212938ZM1.6671 10.3952L8.78935 3.27295L12.7268 7.21044L5.60459 14.3327C5.52469 14.4124 5.42733 14.4724 5.32023 14.508L0.956548 15.9625C0.882511 15.9876 0.804883 16.0003 0.726728 16.0003C0.61155 16.0003 0.498041 15.9728 0.395543 15.9203C0.293045 15.8677 0.204491 15.7916 0.137169 15.6982C0.0698483 15.6047 0.0256855 15.4966 0.00831692 15.3827C-0.00905171 15.2689 0.000870472 15.1525 0.0372666 15.0432L1.49183 10.6796C1.5274 10.5725 1.5874 10.4751 1.6671 10.3952Z",
    fill: "#101010"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3724_53"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.668101a00ad80462ce783137baa2f9f6.svg";
export { ForwardRef as ReactComponent };